import { action } from '@ember/object';
import Component from '@glimmer/component';
import { getColorFromInitiativeTitle } from 'scaleflow/utils/colorClasses';

export default class ListInitiativesBadgeComponent extends Component {
  get value() {
    return this.args.value ?? undefined;
  }

  @action
  onInitiativeSelect(team) {
    this.args?.onSelect?.(team);
  }

  get initiativeColorClass() {
    return getColorFromInitiativeTitle(this.args.value.get('title') ?? '');
  }
}
